import { fixDateValue } from ".";

/**
 * 获取生成一个唯一字符串标识
 * @params t {Date | number } 时间对象或毫秒值时间戳
 * @returns string length=12
 */
export default (t?: Date | number): string => {
  let time = t || Date.now();
  const randomStr = Number(String(Math.random()).slice(2)).toString(36);
  if (time instanceof Date) {
    time = time.valueOf();
  }
  time = fixDateValue(time);
  const nowStr = time.toString(36);
  return `${randomStr.slice(-6)}${nowStr.slice(-6)}`;
};
